"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAnchorId;
// Anchor ID must start with a non-digit character!
// https://stackoverflow.com/questions/37270787/uncaught-syntaxerror-failed-to-execute-queryselector-on-document
function getAnchorId(id) {
  return "anchor-id-".concat(id);
}